import React from 'react';

export const COLUMN_HIDE = "COLUMN_HIDE";
export const COLUMN_SHOW = "COLUMN_SHOW";
export const COLUMN_TRUNCATE = "COLUMN_TRUNCATE";
export const COLUMN_EXPAND_ROW = "COLUMN_EXPAND_ROW";

const ConditionalColumnTableDisplay = ({ parameter, formatter, tooltipFormatter }) => {

    if (parameter === COLUMN_SHOW) {

        return formatter(false);
    }

    if (parameter === COLUMN_TRUNCATE) {

        return (
            tooltipFormatter() != null ?
                <div className="btn-link valueTooltip"
                    style={{
                        cursor: "pointer"
                    }}
                    data-toggle="tooltip"
                    data-placement="left"
                    data-html={true}
                    title={tooltipFormatter()}
                    data-original-title={tooltipFormatter()}
                >
                    {formatter(true)}

                </div>
                : formatter(true)
        )
    }

    return null;
}

export default ConditionalColumnTableDisplay;